import script from "./Dome.vue?vue&type=script&setup=true&lang=js"
export * from "./Dome.vue?vue&type=script&setup=true&lang=js"

import "./Dome.vue?vue&type=style&index=0&id=172a4eb7&scoped=true&lang=css"

import exportComponent from "/builds/skilltech-ph/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-172a4eb7"]])

export default __exports__